import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AuthCardLayout } from '@/components/AuthCardLayout'
import { FormInput, SubmitButton } from '@/components/form'
import { usersService } from '@/services/users'
import { ROUTES } from '@/constants/routes'
import { getApiErrorMessage } from '@/utils/errors'

export function ForgotPasswordPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setIsLoading(true)
    try {
      await usersService.requestPasswordReset({ email: email.trim() })
      navigate(`${ROUTES.RESET_PASSWORD_VERIFY}?email=${encodeURIComponent(email.trim())}`)
    } catch (err) {
      setError(getApiErrorMessage(err, t('forgotPassword.error')))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthCardLayout title={t('forgotPassword.title')} subtitle={t('forgotPassword.instructions')}>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        {error && (
          <div
            className="flex items-start gap-3 rounded-lg border border-red-300 bg-red-50 p-4"
            role="alert"
          >
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}
        <FormInput
          id="forgot-email"
          label={t('forgotPassword.emailLabel')}
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder={t('forgotPassword.emailPlaceholder')}
          autoComplete="email"
          required
          disabled={isLoading}
        />
        <SubmitButton
          fullWidth
          showIcon={false}
          isLoading={isLoading}
          loadingLabel={t('forgotPassword.submitting')}
        >
          {t('forgotPassword.submitButton')}
        </SubmitButton>
      </form>
    </AuthCardLayout>
  )
}
